import DebugUANC from '../core/version/debug';

export const loadGPTScript = (): Promise<void> => {
    return new Promise((resolve, reject) => {
        if (window.googletag.apiReady) return resolve();
        const { detection, event, UANC } = window.Inpl.Ad;

        const gptScript = document.createElement('script');
        gptScript.async = true;
        gptScript.type = 'text/javascript';
        gptScript.src = `${detection?.protocol}//securepubads.g.doubleclick.net/tag/js/gpt.js`;

        const comment = document.createComment('Googletag: gpt');
        const headTag = document.getElementsByTagName('head')[0];
        headTag.appendChild(comment);
        headTag.appendChild(gptScript);

        event?.subscribe('load', gptScript, () => {
            UANC instanceof DebugUANC && UANC.info('GPT script loaded successfully');
            return resolve();
        });

        event?.subscribe('error', gptScript, () => {
            return reject(new Error('Error loading GPT script'));
        });
        event?.subscribe('abort', gptScript, () => {
            return reject(new Error('GPT script loading aborted'));
        });
    });
};
